import React from "react";
import "./spiner.css";

const Spiner = () => {
  return (

    <div className=" loadingio-spinner-double-ring-iu9f1loi92r ">
      <div className="ldio-3bn2fity463">
        <div></div>
        <div></div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </div>

  );
};

export default Spiner;
